import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { 
  HiOutlineMenu, 
  HiOutlineX, 
  HiOutlineSearch,
  HiOutlineLogout,
  HiOutlineUserCircle,
  HiOutlineChevronDown
} from 'react-icons/hi';
import NotificationBell from '../NotificationBell';
import LogoutConfirmationModal from '../LogoutConfirmationModal';
import './Topbar.scss';

const Topbar = ({ 
  onToggleSidebar, 
  onToggleMobileSidebar,
  isSidebarCollapsed 
}) => {
  const { user, employees } = useSelector(state => state.auth);
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  // Find current user's data
  const currentUserData = user && employees.length > 0 
    ? employees.find(employee => employee.email === user.email)
    : null;
  
  // Handle click outside dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  
  const handleLogoutClick = () => {
    setIsDropdownOpen(false); // Close dropdown first
    setIsLogoutModalOpen(true); // Open logout confirmation modal
  };
  
  return (
    <header className="topbar">
      <div className="left-section">
        <button 
          className="sidebar-toggle desktop-toggle" 
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          {isSidebarCollapsed ? 
            <HiOutlineMenu size="24px" className="large-icon" /> : 
            <HiOutlineX size="24px" className="large-icon" />
          }
        </button>
        <button 
          className="sidebar-toggle mobile-toggle" 
          onClick={onToggleMobileSidebar}
          aria-label="Toggle mobile sidebar"
        >
          <HiOutlineMenu size="24px" className="large-icon" />
        </button>
        <div className="logo">
          <img 
            src="/myelinz-logo-white.svg" 
            alt="Myelinz Logo" 
            className="company-logo"
          />
          <span className="logo-full">PPC Portal</span>
          <span className="logo-icon">AD</span>
        </div>
      </div>

      <div className="search-container">
        <div className="search-wrapper">
          <HiOutlineSearch className="search-icon" />
          <input 
            type="text" 
            placeholder="Search..." 
            className="search-input" 
          />
        </div>
      </div>

      <div className="right-section">
        <NotificationBell />
        
        <div className="user-profile-dropdown" ref={dropdownRef}>
          <button 
            className="user-profile-button"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <div className="user-profile">
              <div className="avatar">
                {currentUserData?.img ? (
                  <img src={currentUserData.img} alt={currentUserData?.name} />
                ) : (
                  <div className="avatar-placeholder">
                    {currentUserData?.name?.charAt(0) || 'U'}
                  </div>
                )}
              </div>
              <div className="user-info">
                <span className="user-name">{currentUserData?.name || 'User'}</span>
                <span className="user-role">{currentUserData?.designation || 'Employee'}</span>
              </div>
              <HiOutlineChevronDown className={`dropdown-icon ${isDropdownOpen ? 'open' : ''}`} />
            </div>
          </button>
          
          {isDropdownOpen && (
            <div className="dropdown-menu">
              <button 
                onClick={() => { navigate('/'); setIsDropdownOpen(false); }} 
                className="dropdown-item"
              >
                <HiOutlineUserCircle className="dropdown-icon" />
                <span>My Profile</span>
              </button>
              <div className="dropdown-divider"></div>
              <button onClick={handleLogoutClick} className="dropdown-item">
                <HiOutlineLogout className="dropdown-icon" />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
      
      {/* Logout Confirmation Modal */}
      <LogoutConfirmationModal 
        isOpen={isLogoutModalOpen}
        onClose={() => setIsLogoutModalOpen(false)}
      />
    </header>
  );
};

export default Topbar; 